import React, { useState } from "react";
import "./Search.css";
import { BiSearchAlt } from "react-icons/bi";
import { TiArrowUnsorted } from "react-icons/ti";
import { useGazette } from "../../../context/GazetteContext";

const Search = ({
  currentLibrary,
  libraries,
  placeholder,
  onSearch,
  hasActNo,
  onLibrariesChange,
  language,
  switchLanguage,
  isBilingual,
  libraryId,
  limit,
  setLimit,
  hasGazetteNo,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [offset, setOffset] = useState(0);

  const { keyword, setKeyword } = useGazette();

  const handleLibraryChange = (e) => {
    const selectedLibrary = e.target.value;
    onLibrariesChange(selectedLibrary);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (onSearch && searchQuery) {
      onSearch(searchQuery, limit, keyword.toLowerCase(), offset);
    }
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
  };

  const handleSearchType = (e) => {
    const newKeyword = e.target.value;
    setKeyword(newKeyword);
  };

  const libraryValueMap = {
    300: 301,
    379: 378,
    302: 303,
    309: 308,
  };

  const getMappedLibraryValue = (value) => {
    return libraryValueMap[value] ?? value;
  };
  return (
    <div style={{ marginTop: "20px" }}>
      {libraries &&
        Array.isArray(libraries.library) &&
        libraries.library.length > 0 && (
          <div className="e-gazette-breadcrumb">
            <span style={{ paddingTop: "0.390625vw" }}>
              E-Gazette &gt; {libraries.name} &gt;{" "}
            </span>
            <div className="library-select-container library-dropdown">
              <select
                value={getMappedLibraryValue(currentLibrary)}
                onChange={handleLibraryChange}
              >
                {Array.isArray(libraries.library) &&
                libraries.library.length > 0 ? (
                  libraries.library
                    .filter((library) => library?.orderId !== null)
                    .map((library) => (
                      <option key={library?.libraryId} value={library?.libraryId}>
                        {library?.displayName}
                      </option>
                    ))
                ) : (
                  <option disabled>No libraries available</option>
                )}
              </select>
              <TiArrowUnsorted
                className="search-custom-arrow"
                size={18}
                color="#a6a8aa"
              />
            </div>
          </div>
        )}
      {libraries && Array.isArray(libraries) && libraries.length === 0 && (
        <div className="e-gazette-breadcrumb">
          <span style={{ paddingTop: "0.390625vw" }}>E-Gazette &gt; All</span>
        </div>
      )}
      <div className="search-container-eg">
        <div>
          <div className="search-select-container">
            <select value={limit} onChange={handleLimitChange}>
              <option>10</option>
              <option>25</option>
              <option>50</option>
            </select>
            <TiArrowUnsorted
              className="search-custom-arrow"
              size={18}
              color="#a6a8aa"
            />
          </div>
          <span className="search-select-text">records per page</span>
        </div>
        <div className="search-select-container search-dropdown">
          <select value={keyword} onChange={handleSearchType}>
            <option>Keyword</option>
            <option>Semantic</option>
            {hasActNo ? <option value="actNo">Act No</option> : null}
            {hasGazetteNo ? (
              <option value="gazetteNo">Gazette No</option>
            ) : null}

            <option>Year</option>
            <option>Title</option>
          </select>
          <TiArrowUnsorted
            className="search-custom-arrow"
            size={18}
            color="#a6a8aa"
          />
        </div>
        <form className="search-box" onSubmit={handleSubmit}>
          <input
            type="text"
            name="search"
            placeholder={placeholder}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button>
            <BiSearchAlt size={16} style={{ transform: "scaleX(-1)" }} />
            Search
          </button>
        </form>
      </div>
      <div className="switch-btn">
        {isBilingual && language === "EN" && (
          <button
            onClick={() => {
              const offset = 0;
              setOffset(offset);
              setSearchQuery("");
              switchLanguage(libraryId);
            }}
          >
            Switch to B. Melayu
          </button>
        )}
        {isBilingual && language === "BM" && (
          <button
            onClick={() => {
              const offset = 0;
              setOffset(offset);
              switchLanguage(libraryId);
            }}
          >
            Tukar ke B.Inggeris
          </button>
        )}
      </div>
    </div>
  );
};

export default Search;
